import { Tooltip as MuiTooltip } from '@mui/material';
import { TooltipProps } from '@mui/material/Tooltip';

const Tooltip = ({
  title,
  children,
  placement = 'right-start',
  arrow,
  slotProps,
  ...rest
}: TooltipProps) => {
  return (
    <MuiTooltip
      title={title}
      placement={placement}
      enterDelay={200}
      leaveDelay={200}
      arrow={arrow}
      slotProps={{
        popper: slotProps?.popper,
        tooltip: {
          sx: {
            maxWidth: '513px',
            bgcolor: 'customSecondary.info.subtle',
            border: '1px solid customSecondary.neutral.400',
            fontSize: '14px',
            padding: '10px 20px',
            lineHeight: '24px',
            boxShadow: '0 8px 24px customSecondary.neutral.400',
            color: 'customSecondary.neutral.100',
          },
        },
        arrow: {
          sx: {
            color: `customSecondary.info.subtle`,
            '&::before': {
              boxShadow: '0 0 0 1px customSecondary.neutral.400',
            },
          },
        },
      }}
      {...rest}
    >
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
